import { StammdatenService } from '../../../../../services/stammdaten.service';
import { Component, Input, OnInit} from '@angular/core';
import { StateService } from '@/core/services/state.service';
import { InstitutionDisplayModelFormGroup } from '@/api/model-index';
import { IbanValidator } from '@/core/validators/iban-validator';
import { BICValidator } from '@/core/validators/bic-validator';

@Component({
  selector: 'bank-data-institution',
  templateUrl: './bank-data-institution.component.html',
  styleUrls: ['./bank-data-institution.component.scss']
})
export class BankDataInstitutionComponent implements OnInit {
  @Input("form") public institutionForm: InstitutionDisplayModelFormGroup;
  
  constructor(protected stateService: StateService, protected stammdatenService: StammdatenService) {
  }

  ngOnInit(): void {
    this.stammdatenService.GetPortalKonfiguration().subscribe(cfg => {
      if (cfg != undefined && cfg.ibanueberpruefung == true) {
        this.institutionForm.Iban.addValidators([new IbanValidator(cfg).validate]);
        this.institutionForm.Bic.addValidators([new BICValidator(cfg).validate]);
      }
    });

    if(this.stateService.IsEndvalidationEnabled) {
      this.institutionForm.markAllAsTouched();
    }

    // used to bubble the value changes to the top form value
    this.institutionForm.valueChanges.subscribe(change =>{
      var change = change;
    });
  }
}
